import { idr } from "../../lib/api";
import { labelBarisBayar } from "../../lib/rincianBayar";

/* ============================================================================
 * Daftar baris pembayaran nota di LAYAR (batch N3, brief 22 Sep 2026 D4/D5/D7):
 * metode + keterangan, trade-in per unit, DP, sisa tagihan tempo, dan kembalian
 * downgrade — semuanya dari `_baris_pembayaran` yang disusun server
 * (`routers/sales.py::susun_baris_pembayaran`). Dipakai detail Penjualan,
 * detail Input Nota, dan jendela approve supaya ketiganya tidak menyusun ulang
 * dari `payments` masing-masing (dulu tiga layar, tiga susunan berbeda).
 * ========================================================================== */
const WARNA = {
  trade_in: "bg-violet-50 border-violet-200",
  dp: "bg-emerald-50 border-emerald-200",
  piutang: "bg-amber-50 border-amber-200",
  kewajiban_pelanggan: "bg-amber-50 border-amber-200",
  kredit_retur: "bg-rose-50 border-rose-200",
};

export default function DaftarBarisPembayaran({ baris, testidPrefix, kosong = null }) {
  const daftar = baris || [];
  if (!daftar.length) return kosong;
  return (
    <div className="space-y-1">
      {daftar.map((b, i) => (
        <div key={i} data-testid={`${testidPrefix}-${i}`}
          className={`flex justify-between gap-2 text-xs rounded px-2 py-1.5 border ${WARNA[b.jenis] || "bg-sky-50 border-sky-200"}`}>
          <span className="min-w-0">
            <span className="font-medium text-slate-900">{labelBarisBayar(b)}</span>
            {b.imei && <span className="block font-mono text-[10px] text-violet-600">IMEI {b.imei}</span>}
            {b.keterangan && <span className="block text-[11px] text-slate-600">{b.keterangan}</span>}
          </span>
          <span className="font-mono font-semibold shrink-0">
            {b.nominal === null || b.nominal === undefined ? "—" : idr(b.nominal)}
          </span>
        </div>
      ))}
    </div>
  );
}
